import { render, staticRenderFns } from "./button-icon.vue?vue&type=template&id=3d9de62b"
import script from "./button-icon.vue?vue&type=script&lang=js"
export * from "./button-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports